import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/vector`;

class VectorService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getVector(id) {
        return axios.get(`${API_URL}/view/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(search) {
        return axios.get(`${API_URL}/getFilter`, {
            params: {
                search: search,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(vector) {
        return axios.post(`${API_URL}/new`, vector, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(vector) {
        return axios.put(`${API_URL}/update`, vector, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new VectorService();